import glossary from "../modulos/glossary/glossary";
import './css/courseHome.scss';

export const loadCourseHome = () => {
    glossary();
}

